/* tslint:disable:interface-name */
import { ApiEndpointConfiguration } from '../../common-react/core';

import { PosturinnServerApi } from './posturinn-server-api.enum';

export interface PosturinnApiEndpointConfiguration extends ApiEndpointConfiguration<PosturinnServerApi> {
}
